<template>
  <div
    class="summary">
    <div>
    <a
      href="javascript:void(0)"
      :style="{ 'font-size': fontSize }"
      @click="expand([], dataChart.metric_name)">{{ metric }}</a>
      <div>{{ dataChart.metric_name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Summary',
  components: {
  },
  props: {
    dataChart: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
    valueType () {
      return {
        'days': ' Dias',
        'percent': '%',
        'number': ''
      }[this.dataChart.value_type]
    },
    metric () {
      return this.dataChart.value
    },
    fontSize () {
      const num = 80 - (String(this.metric).length * 5)
      return num + 'px'
    }
  },
  created () {
  },
  methods: {
    expand (filters, name) {
      this.$emit('expand', { filters, name })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.summary {
  height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ReportChart/Summary.vue